export const filters = {
    date: "",
    timeIn: "",
    timeOut: "",
    noOfGuests: "",
    isCheckedFullDay: false,
    name: '',
    resourceType: null,
    reservationPeriod: 0
}